/**
 * Enum representing the pickled titles.
 *
 * @description Contains values which are used in the store to keep the
 * pickled values.
 */
export enum PickleTitles {
    OneTimeCarRental = 'oneTimeCarRental',
    OneTimeFingerprinting = 'oneTimeFingerprinting',
    OneTimeParking = 'oneTimeParking',
    OneTimeScrubs = 'oneTimeScrubs',
    OneTimeTaxable = 'oneTimeTaxable',
    OneTimeOtherCost = 'oneTimeOtherCost',
    MonthlyCarRental = 'monthlyCarRental',
    MonthlyParking = 'monthlyParking',
    MonthlyOtherCost = 'monthlyOtherCost',
    Referral = 'referral',
    Discretionary = 'discretionary'
}

/**
 * Enum representing the pickled titles to display.
 *
 * @description Human readable pickled titles. Displayed on CalculationDetails
 * component.
 */
export enum PickleTitlesDisplay {
    OneTimeCarRental = 'One-Time Car Rental',
    OneTimeFingerprinting = 'One-Time Fingerprinting',
    OneTimeParking = 'One-Time Parking',
    OneTimeScrubs = 'One-Time Scrubs',
    OneTimeTaxable = 'One-Time Taxable',
    OneTimeOtherCost = 'One-Time Other Cost',
    MonthlyCarRental = 'Monthly Car Rental',
    MonthlyParking = 'Monthly Parking',
    MonthlyOtherCost = 'Monthly Other Cost',
    Discretionary = 'Discretionary',
    Referral = 'Referral'
}

/**
 * Enum representing the pickled titles captions.
 *
 * @description Readable captions for the pickled titles. Displayed on
 * total reimbursement section.
 */
export enum PickleTitleCaption {
    CarRental = 'Car Rental',
    Fingerprinting = 'Fingerprinting',
    Parking = 'Parking',
    Scrubs = 'Scrubs',
    Taxable = 'Taxable',
    OtherCost = 'Other Cost',
    Discretionary = 'Discretionary',
    Referral = 'Referral'
}
